import React, { useState } from 'react';
import {
  Box,
  Container,
  Paper,
  Tabs,
  Tab,
  Typography,
  useTheme,
} from '@mui/material';
import { TemplateManagement } from '../components/admin/TemplateManagement';
import { UserManagement } from '../components/admin/UserManagement';
import { DashboardOverview } from '../components/admin/DashboardOverview';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export const AdminDashboard: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const theme = useTheme();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Admin Dashboard
        </Typography>

        <Paper sx={{ width: '100%', mb: 2 }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Overview" />
            <Tab label="Templates" />
            <Tab label="Users" />
          </Tabs>
        </Paper>

        <TabPanel value={currentTab} index={0}>
          <DashboardOverview />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <TemplateManagement />
        </TabPanel>

        <TabPanel value={currentTab} index={2}>
          <UserManagement />
        </TabPanel>
      </Box>
    </Container>
  );
}; 

export default AdminDashboard;
